module.exports = __webpack_public_path__ + "img/certified.1f6d302b.svg";